import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../services/PremissionChecker";
function ColorSchemes() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [colorSchemeData, setColorSchemeData] = useState([]);
  const [addLoading, setAddLoading] = useState(false);

  const [addModal, setAddModal] = useState(false);
  const [unitName, setUnitName] = useState("");
  const [sideBarColor, setSideBarColor] = useState("");
  const [sideBarBgColor, setSideBarBgColor] = useState("");
  const [sideBarHoverColor, setSideBarHoverColor] = useState("");
  const [navBarColor, setNavBarColor] = useState("");
  const [navBarTxtColor, setNavBarTxtColor] = useState("");
  const [navBarDateColor, setNavBarDateColor] = useState("");
  const [btnColor, setBtnColor] = useState("");
  const [txtColor, setTxtColor] = useState("");
  const [logo, setLogo] = useState(null);

  const [editColorModal, setEditColorModal] = useState(false);
  const [editColorId, setEditColorId] = useState("");
  const [editUnitName, setEditUnitName] = useState("");
  const [editSideBarColor, setEditSideBarColor] = useState("");
  const [editSideBarBgColor, setEditSideBarBgColor] = useState("");
  const [editSideBarHoverColor, setEditSideBarHoverColor] = useState("");
  const [editNavBarColor, setEditNavBarColor] = useState("");
  const [editNavBarTxtColor, setEditNavBarTxtColor] = useState("");
  const [editNavBarDateColor, setEditNavBarDateColor] = useState("");
  const [editBtnColor, setEditBtnColor] = useState("");
  const [editTxtColor, setEditTxtColor] = useState("");
  const [editLogo, setEditLogo] = useState(null);

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteColorId, setDeleteColorId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getColorSchemes();
  }, []);

  const getColorSchemes = async () => {
    setloading(true);
    await fetch(`${baseUrl}/color-schemes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setColorSchemeData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addColorSchemeHandler = async () => {
    if (
      !unitName ||
      !isValidHex(sideBarColor) ||
      !isValidHex(sideBarBgColor) ||
      !isValidHex(sideBarHoverColor) ||
      !isValidHex(navBarColor) ||
      !isValidHex(navBarTxtColor) ||
      !isValidHex(navBarDateColor) ||
      !isValidHex(btnColor) ||
      !isValidHex(txtColor)
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const formData = new FormData();
    formData.append("name", unitName);
    formData.append("logo", logo);
    formData.append("side_bar_color", sideBarColor);
    formData.append("side_bar_bg_color", sideBarBgColor);
    formData.append("side_bar_hover_color", sideBarHoverColor);
    formData.append("nav_bar_color", navBarColor);
    formData.append("nav_bar_txt_color", navBarTxtColor);
    formData.append("nav_bar_date_color", navBarDateColor);
    formData.append("btn_color", btnColor);
    formData.append("txt_color", txtColor);

    setAddLoading(true);

    await fetch(`${baseUrl}/color-schemes`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: formData,
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Color Scheme successfully added");
            setAddModal(false);
            setAddLoading(false);
            getColorSchemes();
            setUnitName("");
            setLogo(null);
            setSideBarColor("");
            setSideBarBgColor("");
            setSideBarHoverColor("");
            setNavBarColor("");
            setNavBarTxtColor("");
            setNavBarDateColor("");
            setBtnColor("");
            setTxtColor("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddModal(false);
            setAddLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddModal(false);
            setAddLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddLoading(false);
        setAddModal(false);
        console.log(err);
      });
  };

  const handleColorChange = (value, setter) => {
    setter(value);
  };

  const handleHexInput = (value, setter) => {
    // Remove #
    let hex = value.replace("#", "");

    // Allow only hex characters
    if (!/^[0-9A-Fa-f]*$/.test(hex)) return;

    // Limit to 6 characters
    if (hex.length > 6) return;

    setter("#" + hex);
  };

  const isValidHex = (value) => {
    return /^#([0-9A-Fa-f]{6})$/.test(value);
  };

  const getEditColorScheme = async (id) => {
    await fetch(`${baseUrl}/color-schemes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditUnitName(data.payload[0]?.name);
          setEditSideBarColor(data.payload[0]?.side_bar_color);
          setEditSideBarBgColor(data.payload[0]?.side_bar_bg_color);
          setEditSideBarHoverColor(data.payload[0]?.side_bar_hover_color);
          setEditNavBarColor(data.payload[0]?.nav_bar_color);
          setEditNavBarTxtColor(data.payload[0]?.nav_bar_txt_color);
          setEditNavBarDateColor(data.payload[0]?.nav_bar_date_color);
          setEditBtnColor(data.payload[0]?.btn_color);
          setEditTxtColor(data.payload[0]?.txt_color);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateColorHandler = async () => {
    if (
      !editUnitName ||
      !isValidHex(editSideBarColor) ||
      !isValidHex(editSideBarBgColor) ||
      !isValidHex(editSideBarHoverColor) ||
      !isValidHex(editNavBarColor) ||
      !isValidHex(editNavBarTxtColor) ||
      !isValidHex(editNavBarDateColor) ||
      !isValidHex(editBtnColor) ||
      !isValidHex(editTxtColor)
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("name", editUnitName);
    editLogo && formData.append("logo", editLogo);
    formData.append("side_bar_color", editSideBarColor);
    formData.append("side_bar_bg_color", editSideBarBgColor);
    formData.append("side_bar_hover_color", editSideBarHoverColor);
    formData.append("nav_bar_color", editNavBarColor);
    formData.append("nav_bar_txt_color", editNavBarTxtColor);
    formData.append("nav_bar_date_color", editNavBarDateColor);
    formData.append("btn_color", editBtnColor);
    formData.append("txt_color", editTxtColor);

    setSubmitLoading(false);
    await fetch(`${baseUrl}/color-schemes/${editColorId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Color Scheme Successfully Updated");
            getColorSchemes();
            setEditColorModal(false);
            setEditUnitName("");
            setEditLogo(null);
            setEditSideBarColor("");
            setEditSideBarBgColor("");
            setEditSideBarHoverColor("");
            setEditNavBarColor("");
            setEditNavBarTxtColor("");
            setEditNavBarDateColor("");
            setEditBtnColor("");
            setEditTxtColor("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditColorModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditColorModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteColorHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/color-schemes/${deleteColorId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            getColorSchemes();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Color Scheme
          </button>
        </div>

        <Table className="mt-5" responsive>
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Unit Name</th>
              <th>Sidebar Color</th>
              <th>Sidebar Bg Color</th>
              <th>Sidebar Hover Color</th>
              <th>Navbar Color</th>
              <th>Navbar Text Color</th>
              <th>Navbar Date Color</th>
              <th>Button Color</th>
              <th>Text Color</th>
              <th>Logo</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {colorSchemeData?.map((colors, index) => (
              <tr className="text-center" key={index}>
                <td>{colors.id}</td>
                <td>{colors.name}</td>
                <td>{colors.side_bar_color}</td>
                <td>{colors.side_bar_bg_color}</td>
                <td>{colors.side_bar_hover_color}</td>
                <td>{colors.nav_bar_color}</td>
                <td>{colors.nav_bar_txt_color}</td>
                <td>{colors.nav_bar_date_color}</td>
                <td>{colors.btn_color}</td>
                <td>{colors.txt_color}</td>
                <td>
                  <img src={colors.logo} alt="logo" width={30} />
                </td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                    onClick={() => {
                      getEditColorScheme(colors?.id);
                      setEditColorId(colors?.id);
                      setEditColorModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                    onClick={() => {
                      setDeleteColorId(colors?.id);
                      setdeleteModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Delete-user.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add Color Scheme Modal */}
        <Modal show={addModal} size="lg" onHide={() => setAddModal(false)}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Color Scheme
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-3">
              {/* Unit Name */}
              <div className="col-md-6 col-sm-12">
                <label className="form-control-label">
                  <b>
                    Enter Unit Name <span style={{ color: "red" }}>*</span>
                  </b>
                </label>
                <input
                  className="form-control"
                  value={unitName}
                  onChange={(e) => setUnitName(e.target.value)}
                  placeholder="Enter Unit Name"
                />
              </div>

              {/* Logo Upload */}
              <div className="col-md-6 col-sm-12">
                <label className="form-control-label">
                  <b>Upload Logo</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setLogo(e.target.files[0])}
                />
              </div>
            </div>

            {/* Color Fields */}
            <div className="row">
              {[
                {
                  label: "Sidebar Color",
                  value: sideBarColor,
                  setter: setSideBarColor,
                },
                {
                  label: "Sidebar Background",
                  value: sideBarBgColor,
                  setter: setSideBarBgColor,
                },
                {
                  label: "Sidebar Hover",
                  value: sideBarHoverColor,
                  setter: setSideBarHoverColor,
                },
                {
                  label: "Navbar Color",
                  value: navBarColor,
                  setter: setNavBarColor,
                },
                {
                  label: "Navbar Text Color",
                  value: navBarTxtColor,
                  setter: setNavBarTxtColor,
                },
                {
                  label: "Navbar Date Color",
                  value: navBarDateColor,
                  setter: setNavBarDateColor,
                },
                { label: "Button Color", value: btnColor, setter: setBtnColor },
                {
                  label: "Button Text Color",
                  value: txtColor,
                  setter: setTxtColor,
                },
              ].map((item, index) => (
                <div className="col-md-6 mb-3" key={index}>
                  <label className="form-control-label">
                    <b>{item.label}</b>
                  </label>

                  <div className="d-flex gap-2">
                    {/* Color Picker */}
                    <input
                      type="color"
                      className="form-control form-control-color"
                      style={{ width: "60px" }}
                      value={item.value || "#000000"}
                      onChange={(e) =>
                        handleColorChange(e.target.value, item.setter)
                      }
                    />

                    {/* HEX Input */}
                    <input
                      type="text"
                      className={`form-control ${
                        item.value && !isValidHex(item.value)
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="#FFFFFF"
                      value={item.value || ""}
                      onChange={(e) =>
                        handleHexInput(e.target.value, item.setter)
                      }
                    />
                  </div>

                  {/* Validation Message */}
                  {item.value && !isValidHex(item.value) && (
                    <div className="text-danger small">
                      Enter valid 6-digit HEX (e.g. #A1B2C3)
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Error Alert */}
            {isallfields && (
              <Alert
                variant="danger"
                onClose={() => setisallfields(false)}
                dismissible
              >
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>Please fill or select all fields</p>
              </Alert>
            )}
          </Modal.Body>

          <Modal.Footer>
            {addLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addColorSchemeHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddModal(false);
                setisallfields(false);
                setUnitName("");
                setLogo(null);
                setSideBarColor("");
                setSideBarBgColor("");
                setSideBarHoverColor("");
                setNavBarColor("");
                setNavBarTxtColor("");
                setNavBarDateColor("");
                setBtnColor("");
                setTxtColor("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Color Scheme Modal */}
        <Modal show={editColorModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Color Scheme
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-3">
              {/* Unit Name */}
              <div className="col-md-6 col-sm-12">
                <label className="form-control-label">
                  <b>
                    Enter Unit Name <span style={{ color: "red" }}>*</span>
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editUnitName}
                  onChange={(e) => setEditUnitName(e.target.value)}
                  placeholder="Enter Unit Name"
                />
              </div>

              {/* Logo Upload */}
              <div className="col-md-6 col-sm-12">
                <label className="form-control-label">
                  <b>Upload Logo</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setEditLogo(e.target.files[0])}
                />
              </div>
            </div>

            {/* Color Fields */}
            <div className="row">
              {[
                {
                  label: "Sidebar Color",
                  value: editSideBarColor,
                  setter: setEditSideBarColor,
                },
                {
                  label: "Sidebar Background",
                  value: editSideBarBgColor,
                  setter: setEditSideBarBgColor,
                },
                {
                  label: "Sidebar Hover",
                  value: editSideBarHoverColor,
                  setter: setEditSideBarHoverColor,
                },
                {
                  label: "Navbar Color",
                  value: editNavBarColor,
                  setter: setEditNavBarColor,
                },
                {
                  label: "Navbar Text Color",
                  value: editNavBarTxtColor,
                  setter: setEditNavBarTxtColor,
                },
                {
                  label: "Navbar Date Color",
                  value: editNavBarDateColor,
                  setter: setEditNavBarDateColor,
                },
                {
                  label: "Button Color",
                  value: editBtnColor,
                  setter: setEditBtnColor,
                },
                {
                  label: "Button Text Color",
                  value: editTxtColor,
                  setter: setEditTxtColor,
                },
              ].map((item, index) => (
                <div className="col-md-6 mb-3" key={index}>
                  <label className="form-control-label">
                    <b>{item.label}</b>
                  </label>

                  <div className="d-flex gap-2">
                    {/* Color Picker */}
                    <input
                      type="color"
                      className="form-control form-control-color"
                      style={{ width: "60px" }}
                      value={item.value || "#000000"}
                      onChange={(e) =>
                        handleColorChange(e.target.value, item.setter)
                      }
                    />

                    {/* HEX Input */}
                    <input
                      type="text"
                      className={`form-control ${
                        item.value && !isValidHex(item.value)
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="#FFFFFF"
                      value={item.value || ""}
                      onChange={(e) =>
                        handleHexInput(e.target.value, item.setter)
                      }
                    />
                  </div>

                  {/* Validation Message */}
                  {item.value && !isValidHex(item.value) && (
                    <div className="text-danger small">
                      Enter valid 6-digit HEX (e.g. #A1B2C3)
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Error Alert */}
            {isallfields && (
              <Alert
                variant="danger"
                onClose={() => setisallfields(false)}
                dismissible
              >
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>Please fill or select all fields</p>
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={updateColorHandler} className="btn btn-primary">
                Update
              </button>
            )}

            <button
              onClick={() => setEditColorModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Color Scheme Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this color scheme?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Color Scheme Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteColorHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default ColorSchemes;
